import React from "react";
import { Grid, xcss } from "@atlaskit/primitives";
import Spinner from "@atlaskit/spinner";

function SuspenseFallback() {
  return (
    <Grid
      alignItems="center"
      justifyContent="center"
      xcss={xcss({ width: "100%", height: "100%" })}
    >
      <Spinner size="large" />
    </Grid>
  );
}

export default SuspenseFallback;
